export function PageHero({
  eyebrow,
  title,
  text,
  primary,
  secondary
}: {
  eyebrow: string;
  title: string;
  text: string;
  primary: { href: string; label: string };
  secondary: { href: string; label: string };
}) {
  return (
    <section className="pageHero">
      <p className="eyebrow">{eyebrow}</p>
      <h1>{title}</h1>
      <p className="heroText">{text}</p>
      <div className="actions">
        <a className="primary" href={primary.href}>
          {primary.label}
        </a>
        <a className="secondary" href={secondary.href}>
          {secondary.label}
        </a>
      </div>
    </section>
  );
}
